import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../services/axiosComman";
import { DoughWithData, DoughWithNoData } from "../../utils/DoughNutChart";

function DashboardChartView({ title = "", url = "",path="" }) {
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    function FilterData(data){
        let statusTempData = Object.entries(data);
        let finalData = statusTempData.filter(([key,value])=>key!=='verified_and_approved')
        let justStrings = Object.fromEntries(finalData);
        return justStrings||[];
      }
    
      async function getFunction() {
        await axiosInstance.get(url).then((res) => {
            setData(res?.data?.data)
        }).catch(err=>{
            console.error(err);
        });
      }

      function genStatusData(statusData) {
        let finalData = FilterData(statusData)
    
        let returnValue = {
          label: [],
          data: [],
        };
        let X = Object.keys(finalData);
        let Y = Object.values(finalData);
        returnValue.label = X;
        returnValue.data = Y;
    
        let sum = Y.reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        }, 0);
        if (sum != 0) {
          return <div className=" w-full h-full cursor-pointer"><DoughWithData bgColor={['#FF0000','#008000','#ffd700',]}  dataWithLabel={returnValue} handleSegmentClick={handleSegmentClick} /></div>;
        } else {
          return <DoughWithNoData />;
        }
      }

      function handleSegmentClick(event, chartElements){
        let color = chartElements[0]?.element?.options?.borderColor
        if( color =="#007300"){
            navigate(path, { state: { statusFilter: "completed" } });
        }else if(color == "#E60000"){
            navigate(path, { state: { statusFilter: "yet to start" } });
        }else if(color == "#E6C300"){
            navigate(path, { state: { statusFilter: "in progress" } });
        }else{
          return false
        }
      }

    useEffect(()=>{
        if(url) getFunction()
    },[url])  
  return (
    <div className=" w-full h-full overflow-hidden rounded-md p-4 bg-white shadow-main">
      <div className=" h-8 text-xs 2xl:text-sm text-center text-[#6E6985]">
        {title || ""}
      </div>
      <div className=" w-full flex flex-col h-[calc(100%-32px)]">
        <div className=" w-full  flex-1  flex justify-center items-center pb-5 px-5">
            <div className=" max-w-[150px] max-h-[150px] flex justify-center items-center overflow-hidden">
            {
                data?genStatusData(data):<DoughWithNoData/>
             }
            </div>
        </div>
        <div className=" h-8">
          <Link
            to={path}
            state={{statusFilter: "yet to start" }}
          >
            <p className="flex justify-between  items-center text-xs 2xl:text-sm  ">
              <span className="flex justify-between items-center font-medium text-[#FF0000]">
                <div className=" w-2 h-2 2xl:w-3 2xl:h-3 rounded-full bg-[#FF0000] mx-1 2xl:mx-2"></div>
                Yet To Start
              </span>
              <span className=" font-medium">{data?.Not_yet_start_percentage||0} %</span>
            </p>
          </Link>
        </div>
        <div className=" h-8">
        <Link
            to={path}
            state={{statusFilter: "in progress" }}
          >
            <p className="flex justify-between  items-center text-xs 2xl:text-sm  ">
              <span className="flex justify-between items-center font-medium text-[#ffd700]">
                <div className=" w-2 h-2 2xl:w-3 2xl:h-3 rounded-full bg-[#ffd700] mx-1 2xl:mx-2"></div>
                In Progress
              </span>
              <span className=" font-medium">{data?.in_progress_percentage||0} %</span>
            </p>
          </Link>
        </div>
        <div className=" h-8 ">
        <Link
            to={path}
            state={{statusFilter: "completed" }}
          >
            <p className="flex justify-between  items-center text-xs 2xl:text-sm  ">
              <span className="flex justify-between items-center font-medium text-[#008000]">
                <div className=" w-2 h-2 2xl:w-3 2xl:h-3 rounded-full bg-[#008000] mx-1 2xl:mx-2"></div>
                Completed
              </span>
              <span className=" font-medium">{data?.complete_percentage||0} %</span>
            </p>
          </Link>
        </div>
        <div className=" h-8 ">
        {
                    data?.verified_and_approved &&
                    <p className="flex justify-between text-xs 2xl:text-sm items-center ">
                    <span className="flex justify-between items-center font-medium text-[#7030A0]">
                      <div className=" w-2 h-2 2xl:w-3 2xl:h-3 rounded-full bg-[#7030A0] mx-1 2xl:mx-2"></div>
                       Reviewed & Approved
                    </span>
                  </p>
                  }
        </div>
      </div>
    </div>
  );
}

export default DashboardChartView;
